<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PviJ1N/images/e9781439632499_cover.jpg?1684514594360" alt="This image is the cover for the book West Chester, Postcard History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">West Chester, Postcard History Series
      </h1>
      <p class="bookDescription body article font2">
        <p>West Chester has grown from the sleepy village originally known as Turk�s Head in the 1700s to a bustling community hosting West Chester University, a thriving educational institution. The selection of West Chester as the seat of Chester County�s government in 1785 led citizens to march on the town �armed with a field-piece, a barrel of whiskey, and other warlike munitions.� Architect Thomas U. Walter, who designed the U.S. Capitol, was responsible for several classic town buildings.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce Edward Mowday
      </h2>
      
      <p class="authorDescription body article">West Chester features postcards from Bruce Edward Mowday�s personal collection. He is the author of three additional books, Along the Brandywine River, Coatesville, and Downingtown. Mowday worked for a West Chester newspaper for more than twenty years. A member of numerous historical organizations and a board member of the Chester County Historical Society, he has written histories of Fort Delaware in the Civil War and the Revolutionary War Battle of Brandywine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48aafac4